import { useMemo } from 'react';
import { TILE_SIZE, FLOOR_HEIGHT } from './constants';
import type { Position } from '@/types/game';

interface HintPath3DProps {
  path: Position[];
  hazards?: Set<string>;
  totalCols: number;
  totalRows: number;
}

export default function HintPath3D({ path, hazards, totalCols, totalRows }: HintPath3DProps) {
  const tiles = useMemo(() => {
    return path.map((pos, i) => {
      const key = `${pos[0]},${pos[1]}`;
      const isHazard = hazards?.has(key) ?? false;
      const x = (pos[0] - (totalCols - 1) / 2) * TILE_SIZE;
      const z = (pos[1] - (totalRows - 1) / 2) * TILE_SIZE;
      return { x, z, isHazard, index: i };
    });
  }, [path, hazards, totalCols, totalRows]);

  const y = FLOOR_HEIGHT + 0.12;

  return (
    <group>
      {tiles.map((tile) => (
        <mesh
          key={tile.index}
          position={[tile.x, y, tile.z]}
          rotation={[-Math.PI / 2, 0, 0]}
        >
          <planeGeometry args={[TILE_SIZE * 0.6, TILE_SIZE * 0.6]} />
          <meshStandardMaterial
            color={tile.isHazard ? '#FF4444' : '#44FF88'}
            emissive={tile.isHazard ? '#FF2222' : '#22CC66'}
            emissiveIntensity={0.3}
            transparent
            opacity={0.4}
            side={2}
          />
        </mesh>
      ))}
    </group>
  );
}
